import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FullscreenIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M17 17V14H19V19H14V17H17ZM5 10V5H10V7H7V10H5Z' fill='currentColor' />
        </>
    ),
})

FullscreenIcon.displayName = 'FullscreenIcon'
